/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-15 16:00:29
 */
import Vue from 'vue'
import Router from 'vue-router'
import compmangeRouter from './modules/router-compmange'
import statisticalRouter from './modules/router-statistical'
import auditRouter from './modules/router-audit'
import helpPrintManage from './modules/router-print-manage'
import routerBook from '@/router/modules/router-book'
import sealManage from './modules/router-seal-manage'
import routerSealBook from './modules/router-seal-book'
import routerSealShare from './modules/router-seal-share-manage'
import gift from './modules/router-gift'
Vue.use(Router)

export default new Router({
  mode: 'history', // history模式
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/views/login'], resolve),
      hidden: true
    },
    ...compmangeRouter,
    ...statisticalRouter,
    ...auditRouter,
    ...helpPrintManage,
    ...routerBook,
    ...sealManage,
    ...routerSealBook,
    ...routerSealShare,
    ...gift
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js